import script from "./DoBChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoBChart.vue?vue&type=script&setup=true&lang=ts"

import "./DoBChart.vue?vue&type=style&index=0&id=1383202d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1383202d"]])

export default __exports__